import { render, staticRenderFns } from "./DLGButtonEdit.vue?vue&type=template&id=aa7a7b48&"
import script from "./DLGButtonEdit.vue?vue&type=script&lang=js&"
export * from "./DLGButtonEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa7a7b48')) {
      api.createRecord('aa7a7b48', component.options)
    } else {
      api.reload('aa7a7b48', component.options)
    }
    module.hot.accept("./DLGButtonEdit.vue?vue&type=template&id=aa7a7b48&", function () {
      api.rerender('aa7a7b48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/components/new/DLGButtonEdit.vue"
export default component.exports